import aggregatedProducts from "./aggregatedProducts";
import auth from "./auth";
import cart from "./cart";
import indexDocument from "./indexDocument";
import main from "./main";
import modebisconfig from "./modebisconfig";
import onboarding from "./onboarding";
import parent from "./parent";
import products from "./products";
import search from "./search";
import ui from "./ui";
import userPackage from "./userPackage";

const rootReducer = {
    auth,
    cart,
    main,
    onboarding,
    parent,
    aggregatedProducts,
    products,
    search,
    ui,
    userPackage,
    modebisconfig,
    indexDocument,
    // labels
};

export default rootReducer;
